module.exports = __webpack_public_path__ + "static/media/discover-incentives.fef5f228.svg";